import { render, staticRenderFns } from "./MlbbJudgesPage.vue?vue&type=template&id=7e6c8baa&scoped=true"
import script from "./MlbbJudgesPage.vue?vue&type=script&lang=js"
export * from "./MlbbJudgesPage.vue?vue&type=script&lang=js"
import style0 from "./MlbbJudgesPage.vue?vue&type=style&index=0&id=7e6c8baa&prod&scoped=true&lang=scss"
import style1 from "./MlbbJudgesPage.vue?vue&type=style&index=1&id=7e6c8baa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e6c8baa",
  null
  
)

export default component.exports